import { IStore } from "../store";
import { IModalElement, INotificationElement, ShowElementEnum } from "./models.d";

/* Selectors */
export const getModals = (state: IStore): IModalElement[] => state.showElement.showedElements.filter(element => element.type === ShowElementEnum.modal) as IModalElement[];
export const getNotifications = (state: IStore) => state.showElement.showedElements.filter(element => element.type === ShowElementEnum.notification) as INotificationElement[];
export const getIsShow = (state: IStore) => state.showElement.isShow;

